import type {
  MemberMonthlySalesResponse,
  OpportunityMonthlySalesResponse,
  OpportunitySummaryResponse,
} from 'backend/types'
import { apiFetch } from '..'

/**
 * オポチュニティサマリー取得API
 *
 * @param startAt - 集計開始日（YYYY-MM-DD形式、オプション）
 * @returns オポチュニティサマリーレスポンス
 * @throws ApiError - 認証失敗（403）、権限不足（403）、サーバーエラー（500）
 */
export async function getOpportunitySummary(startAt?: string): Promise<OpportunitySummaryResponse> {
  // クエリパラメータを構築
  const params = new URLSearchParams()
  if (startAt) {
    params.append('startAt', startAt)
  }

  const queryString = params.toString()
  const url = `/api/opportunity/summary${queryString ? `?${queryString}` : ''}`

  return apiFetch<OpportunitySummaryResponse>(url, { method: 'GET' })
}

/**
 * メンバー月次売上一覧取得API
 *
 * ログイン中のメンバーが起票したオポチュニティに紐づく売上情報を取得します。
 *
 * @param params - クエリパラメータ
 * @param params.period - 期間（YYYY-MM形式、オプション）
 * @param params.offset - オフセット（デフォルト: 0）
 * @param params.limit - 上限（オプション）
 * @returns メンバー月次売上一覧レスポンス
 * @throws ApiError - 認証失敗（403）、権限不足（403）、サーバーエラー（500）
 */
export async function getMemberMonthlySales(params?: {
  period?: string
  offset?: number
  limit?: number
}): Promise<MemberMonthlySalesResponse> {
  // クエリパラメータを構築
  const queryParams = new URLSearchParams()
  if (params?.period) {
    queryParams.append('period', params.period)
  }
  if (params?.offset !== undefined) {
    queryParams.append('offset', params.offset.toString())
  }
  if (params?.limit !== undefined) {
    queryParams.append('limit', params.limit.toString())
  }

  const queryString = queryParams.toString()
  const url = `/api/opportunity/member/monthly-sales${queryString ? `?${queryString}` : ''}`

  return apiFetch(url, { method: 'GET' })
}

/**
 * オポチュニティ月次売上一覧取得API
 *
 * @param opportunityId - オポチュニティID
 * @param params - クエリパラメータ
 * @returns 月次売上一覧レスポンス
 * @throws ApiError
 */
export async function getOpportunityMonthlySales(
  opportunityId: number,
  params?: {
    period?: string
    offset?: number
    limit?: number
  },
): Promise<OpportunityMonthlySalesResponse> {
  const queryParams = new URLSearchParams()
  if (params?.period) {
    queryParams.append('period', params.period)
  }
  if (params?.offset !== undefined) {
    queryParams.append('offset', params.offset.toString())
  }
  if (params?.limit !== undefined) {
    queryParams.append('limit', params.limit.toString())
  }

  const queryString = queryParams.toString()
  const url = `/api/opportunity/${opportunityId}/monthly-sales${queryString ? `?${queryString}` : ''}`

  return apiFetch<OpportunityMonthlySalesResponse>(url, { method: 'GET' })
}
